import { render } from "./TotalRevenue.vue?vue&type=template&id=a83d3d82&scoped=true"
import script from "./TotalRevenue.vue?vue&type=script&lang=js"
export * from "./TotalRevenue.vue?vue&type=script&lang=js"

import "./TotalRevenue.vue?vue&type=style&index=0&id=a83d3d82&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a83d3d82"]])

export default __exports__